import { combineReducers } from 'redux';

import { reducer as suppliersReducer } from './Suppliers/reducer';
import { reducer as uploadReducer } from './upload/reducer';

export const reducer = combineReducers({
	suppliers: suppliersReducer,
	upload: uploadReducer,
});
